export const defaultComputerAllSelector = (state) =>
  state?.defaultComputerReducer?.defaultComputerAll;
export const defaultComputerSelectedSelector = (state) =>
  state?.defaultComputerReducer?.defaultComputerSelected;
export const defaultComputerOpenAddSelector = (state) =>
  state?.defaultComputerReducer?.defaultComputerOpenAdd;
